import { Stage } from '@xbcb/core';

// Email Addresses
export const Email = {
  FDA: {
    [Stage.ALPHA]: 'fda-notice-alpha@inlt.io',
    [Stage.BRAVO]: 'fda-notice-bravo@inlt.io',
    [Stage.BETA]: 'fda-notice-beta@inlt.io',
    [Stage.GAMMA]: 'fda-notice-gamma@inlt.io',
    [Stage.PROD]: 'fda-notice@inlt.io',
  },
  PMS: {
    [Stage.ALPHA]: 'pms-test-alpha@inlt.io',
    [Stage.BETA]: 'pms-test-beta@inlt.io',
    [Stage.BRAVO]: 'pms-test-bravo@inlt.io',
    [Stage.GAMMA]: 'pms-test-gamma@inlt.io',
    [Stage.PROD]: 'pms@inlt.io',
  },
};

export const pmsRequestEmail = 'periodicstatement@dhs.gov';
export const pmsSupportEmail = 'inlt-activations@amazon.com';

export const pmsApplicationSignerName = 'CHRISTOPHER REYNOLDS, ATTY-IN-FACT';
export const pmsApplicationSignerPhone = '215-330-6295';

export const confidentialitySupportEmail = 'inlt-support@amazon.com';
